export default function reducer(state={
    sliders:[],
    specialTours:[],
    dayTours:[],
    roundTours:[],
    maldiveTours:[],
    excursions:[],
    rentVehicle:[],
    serves: [],
    travelEssential: null,
    latestNews: [],
    redUpdate: false,
    spDayTours:[],
    SpRoundTours:[],
    cars:[],
    blogs:[],
    custCare: null,
    travelEss: null,
    hyperLinks:[],
    hyperLinkTours:[],
    hyperLinkDetail:{
        title:"",
        description:"",
        key_words:"",
        meta_description:"",
        tour_type:2
    }
},action){
switch(action.type){
    case "STORE_HOME_TOUR_LIST":{
        return{...state,
            sliders: action.list.sliders,
            excursions: action.list.excursions,
            serves: action.list.serves,
            travelEssential: action.list.travel_essential,
            latestNews: action.list.lates_news,
            redUpdate: true
        }
    }
    case "STORE_HOME_SPECIAL_TOURS": {
        return{...state,
            specialTours: action.list.special_tours,
            redUpdate: true
        }
    }
    case "STORE_HOME_DAY_TOURS": {
        return{...state,
            dayTours: action.list.day_tours,
            redUpdate: true
        }
    }
    case "STORE_HOME_ROUND_TOURS": {
        return{...state,
            roundTours: action.list.round_tours,
            redUpdate: true
        }
    }
    case "STORE_HOME_MALDIVE_TOURS": {
        return{...state,
            maldiveTours: action.list.destinations,
            redUpdate: true
        }
    }
    case "STORE_HOME_REDUCER_UPDATE":{
        return{...state,
            redUpdate: action.bool
        }
    }
    case "STORE_SPECIAL_TOURS_LISTING": {
        return{...state,
            spDayTours:action.list.day_tours,
            SpRoundTours:action.list.round_tours
        }
    }
    case "STORE_SEARCH_RESULT_LIST": {
        return{...state,
            dayTours:action.list.day_tours,
            roundTours:action.list.round_tours,
            excursions:action.list.excursions,
            rentVehicle:action.list.rent_vehicles
        }
    }
    case "STORE_RENT_CAR_LIST": {
        return{...state,
            cars: action.list.cars
        }
    }
    case "STORE_BLOG_LIST": {
        return{...state,
            blogs: action.list.blogs
        }
    }
    case "STORE_CUSTOMER_CARE_LIST": {
        return{...state,
            custCare: action.list.customer_care
        }
    }
    case "STORE_TRAVEL_ESSENSE_DETAILS": {
        return{...state,
            travelEss: action.list.travel_essential
        }
    }
    case "STORE_HYPER_LINK_TOURS": {
        return{...state,
            hyperLinks: action.list.hyperLinks
        }
    }
    case "STORE_HYPER_LINK_TYPE_TOURS": {
        return{...state,
            hyperLinkTours:action.data.tours,
            hyperLinkDetail:action.data.hyperLink
        }
    }
    default:
        break;
}
return state
}